module.exports = __webpack_public_path__ + "static/media/streaming-white.9725e4ed.svg";